import { TokenUtils } from '@philips-emr/hpms-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { applicationContext } from '@philips-emr/tws-foundation';

import { FragmentNames, RootRoutes } from '../../codegen';
import { RedirectAliases } from '../../codegen/constants/aliases/redirect-aliases';

import BaseController from './base-controller';

@Controller({ fragment: FragmentNames.REDIRECT })
class RedirectController extends BaseController {

  @OnMount(RedirectAliases.LAYOUT_REDIRECT)
  onMount(): void {
    applicationContext.clearNavigationStack();
    const { nrSeqBeneficiario, cdPessoaFisica } = TokenUtils.getValues();
    this.context.set({ nrSeqBeneficiario, cdPessoaFisica });
    this.historyService.push(RootRoutes.ROUTE_APPLICATION, { nrSeqBeneficiario });
  }
}

export {
  RedirectController,
};
